export default {
  title: 'Set up authentication',
  subTitle: 'Select the app you would like to proceed with:',
  googleAuthenticator: 'Google Authenticator',
  microsoftAuthenticator: 'Microsoft Authenticator',
};
